<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24.796"
    height="22.488"
    viewBox="0 0 24.796 22.488"
  >
    <g transform="translate(-365.068 -575.265)">
      <path
        d="M384.6,597.753a.513.513,0,0,1-.159-.026l-11.423-3.849h-7.454a.5.5,0,0,1-.5-.5v-8.47a.5.5,0,0,1,.37-.482.5.5,0,0,1,.562.231,9.459,9.459,0,0,0,1.834,2.262c1.207,1.262,2.7,1.233,5.034-.065a.687.687,0,0,0,.417-.525c.091-.7-.8-1.736-1.121-2.046a.5.5,0,0,1,.618-.78c.384.246,9.419,6.057,11.365,8.073,2.115,2.192.981,5.688.932,5.835a.5.5,0,0,1-.475.342Zm-18.536-4.875H373.1a.507.507,0,0,1,.16.026l10.991,3.7c.2-.935.455-3.006-.827-4.336-1.329-1.377-6.394-4.784-9.231-6.652a2.073,2.073,0,0,1,.08.84,1.679,1.679,0,0,1-.922,1.268c-1.717.958-4.229,1.988-6.218-.091a10.112,10.112,0,0,1-1.069-1.127Z"
        fill="#777"
      />
      <path
        d="M382.48,588.129s1.2-3.568,1.87-5.7a8.682,8.682,0,0,0-.9-6.519.5.5,0,0,0-.9.432c1.143,2.392,1.389,4.069.849,5.787-.668,2.126-1.865,5.681-1.865,5.681Z"
        fill="#777"
      />
      <path
        d="M382.28,579.033a.5.5,0,0,0,.493-.424l.322-2.084,1.729.885a.5.5,0,1,0,.455-.891l-2.345-1.2a.506.506,0,0,0-.455,0,.5.5,0,0,0-.267.369l-.427,2.769a.5.5,0,0,0,.418.57A.486.486,0,0,0,382.28,579.033Z"
        fill="#777"
      />
      <path
        d="M386.715,587.149a.5.5,0,0,0,.459-.3,32.133,32.133,0,0,0,1.468-4.145,5.2,5.2,0,0,0,0-2.481,23.727,23.727,0,0,0-1.113-2.367.5.5,0,0,0-.879.475,24.05,24.05,0,0,1,1.045,2.2,4.259,4.259,0,0,1-.024,1.919,30.953,30.953,0,0,1-1.419,4,.5.5,0,0,0,.258.658.492.492,0,0,0,.2.042Z"
        fill="#777"
      />
      <path
        d="M386.685,580.949a.5.5,0,0,0,.493-.426l.246-1.633,1.747.729a.5.5,0,0,0,.385-.924l-2.339-.974a.5.5,0,0,0-.654.27.533.533,0,0,0-.032.117l-.341,2.267a.5.5,0,0,0,.42.568A.453.453,0,0,0,386.685,580.949Z"
        fill="#777"
      />
      <path
        d="M378.7,586.13a.5.5,0,0,0,.465-.317c.061-.151,1.453-3.749-.027-6.443a.5.5,0,0,0-.876.48c1.256,2.288-.013,5.563-.026,5.6a.5.5,0,0,0,.28.649.509.509,0,0,0,.184.035Z"
        fill="#777"
      />
      <path
        d="M377.893,581.171a.5.5,0,0,0,.483-.373l.388-1.472,1.528.588a.5.5,0,0,0,.36-.934l-2.049-.788a.5.5,0,0,0-.646.287.363.363,0,0,0-.017.053l-.53,2.012a.5.5,0,0,0,.356.61A.452.452,0,0,0,377.893,581.171Z"
        fill="#777"
      />
    </g>
  </svg>
</template>
